import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import * as ROUTES from "../../../../constants/routes";

import "./style.scss";

/*
    Props:
        isActive
    State:
        isDisplayed
        isVisible
*/

// class CloseButton extends React.Component {
const CloseButton = ({ isActive, type }) => {
  const [isDisplayed, setIsDisplayed] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [didClick, setDidClick] = useState(false);
  const [currentType, setCurrentType] = useState(null);

  const effectTime = 0.2; // (seconds). Make sure this matches the CSS transition time.

  const goHome = () => {
    window.history.pushState({}, "", ROUTES.INDEX);

    var popStateEvent = new PopStateEvent("popstate", { state: {} });
    window.dispatchEvent(popStateEvent);
  };

  const goBack = () => {
    window.history.back();

    /* var popStateEvent = new PopStateEvent("popstate", { state: {} });
    window.dispatchEvent(popStateEvent); */
  };

  const onClick = () => {
    if (currentType == "exit") {
      setIsVisible(false);
    }
    setDidClick(true);
  };
  useEffect(() => {
    if (didClick) {
      if (currentType == "exit") {
        goHome();
      } else {
        goBack();
      }

      setTimeout(() => {
        setDidClick(false);
      }, (effectTime + 0.1) * 1000);
    }
  }, [didClick]); // Only re-run the effect if didClick changes

  const updateActive = () => {
    const newActive = isActive;

    if (newActive) {
      setIsDisplayed(true);
      setTimeout(function () {
        setIsVisible(true);
      }, 0);
    } else {
      setIsVisible(false);
      setTimeout(function () {
        setIsDisplayed(false);
      }, effectTime * 1000);
    }
  };

  useEffect(() => {
    updateActive();
  }, [isActive]); // Only re-run the effect if isActive changes

  useEffect(() => {
    setIsVisible(false);
    setTimeout(function () {
      setCurrentType(type);
      setTimeout(function () {
        setIsVisible(true);
      }, 10);
    }, effectTime * 1000);
  }, [type]); // Only re-run the effect if type changes

  // render() {
  return (
    <div
      className={`CloseButton container fixed ${isDisplayed ? "active" : ""} ${
        isVisible ? "visible" : ""
      } ${didClick ? "did-click" : ""} ${
        "" /* this.props.isVertical ? "" : "horizontal" */
      }`}
    >
      <button
        type="button"
        className={`close-page-button ${
          currentType == "back" ? "back-close-type" : ""
        } ${currentType == "exit" ? "exit-close-type" : ""}`}
        onClick={onClick}
      >
        <div className="x-bar x-bar-1"></div>
        <div className="x-bar x-bar-2"></div>
        <div className="back-bar back-bar-1"></div>
        <div className="back-bar back-bar-2"></div>
      </button>
    </div>
  );
  // }
};

export default CloseButton;
